<template>
  <div class="w100 statistical bor-ra">
    <div class="w100 accrual-head po-a"></div>
    <div>
      <div class="stastic-warp po-r bor-ra" v-loading="headLoading">
        <div class="stastic-title">服务概况</div>
        <div class="stastic-head-warp">
          <div
            class="stastic-head-cell"
            :style="`background-image: url(${baseUrl}images/wave.png)`"
          >
            <div class="cell-item">
              <div class="cell-left">
                <div class="cell-left-sum">
                  {{ headJson.currentDayApply }}<span>件</span>
                </div>
                <div class="cell-left-type">今日受理</div>
              </div>
              <div class="cell-right"></div>
            </div>
            <div class="cell-icon">
              <img :src="`${baseUrl}images/jytj.png`" />
            </div>
          </div>
          <div
            class="stastic-head-cell"
            :style="`background-image: url(${baseUrl}images/wave.png)`"
          >
            <div class="cell-item">
              <div class="cell-left" style="padding-left: 80px">
                <div class="cell-left-sum">
                  {{ headJson.currentDayFinish }} <span>件</span>
                </div>
                <div class="cell-left-type">今日办结</div>
              </div>
              <div class="cell-right"></div>
            </div>
            <div class="cell-icon">
              <img :src="`${baseUrl}images/ewre.png`" />
            </div>
          </div>
          <div
            class="stastic-head-cell"
            :style="`background-image: url(${baseUrl}images/wave.png)`"
          >
            <div class="cell-item">
              <div class="cell-left">
                <div class="cell-left-sum">
                  {{ headJson.currentWeekFinish }} <span>件</span>
                </div>
                <div class="cell-left-type">本周办件</div>
              </div>
              <div class="cell-right">
                <div
                  class="cell-right-sum"
                  v-show="
                    headJson.currentWeekFinish - headJson.lastWeekFinish + '' !=
                    'NaN'
                  "
                >
                  <span
                    class="flag"
                    v-if="
                      headJson.currentWeekFinish - headJson.lastWeekFinish > 0
                    "
                  >
                    ↑
                  </span>
                  <span
                    class="flag"
                    v-if="
                      headJson.currentWeekFinish - headJson.lastWeekFinish < 0
                    "
                  >
                    ↓
                  </span>
                  {{ headJson.currentWeekFinish - headJson.lastWeekFinish }}
                </div>
              </div>
            </div>
            <div class="cell-icon">
              <img :src="`${baseUrl}images/jytj.png`" />
            </div>
          </div>
          <div
            class="stastic-head-cell"
            :style="`background-image: url(${baseUrl}images/wave.png)`"
          >
            <div class="cell-item">
              <div class="cell-left">
                <div class="cell-left-sum">
                  {{ headJson.currentMonthFinish }}<span>件</span>
                </div>
                <div class="cell-left-type">本月办件</div>
              </div>
              <div class="cell-right">
                <div
                  class="cell-right-sum"
                  v-show="
                    headJson.currentMonthFinish -
                      headJson.lastMonthFinish +
                      '' !=
                    'NaN'
                  "
                >
                  <span
                    class="flag"
                    v-if="
                      headJson.currentMonthFinish - headJson.lastMonthFinish > 0
                    "
                  >
                    ↑
                  </span>
                  <span
                    class="flag"
                    v-if="
                      headJson.currentMonthFinish - headJson.lastMonthFinish < 0
                    "
                  >
                    ↓
                  </span>
                  {{ headJson.currentMonthFinish - headJson.lastMonthFinish }}
                </div>
              </div>
            </div>
            <div class="cell-icon">
              <img :src="`${baseUrl}images/jytj.png`" />
            </div>
          </div>
          <div
            class="stastic-head-cell"
            :style="`background-image: url(${baseUrl}images/wave.png)`"
          >
            <div class="cell-item">
              <div class="cell-left">
                <div class="cell-left-sum">
                  {{ headJson.active }}<span>件</span>
                </div>
                <div class="cell-left-type">办理中</div>
              </div>
              <div class="cell-left" style="padding-left: 40px">
                <div class="cell-left-sum">
                  {{ headJson.finished }}<span>件</span>
                </div>
                <div class="cell-left-type">已结办</div>
              </div>
            </div>
            <div class="cell-icon">
              <img :src="`${baseUrl}images/fgfd.png`" />
            </div>
          </div>
        </div>
      </div>
      <!--<div class="stastic-sc cl-f">-->
      <!--<div class="stastic-sc-cell">-->
      <!--<div class="stastic-title">服务人数及实名认证</div>-->
      <!--<div class="stastic-sc-con">-->
      <!--<div class="stastic-sc-con-left">-->
      <!--<div class="icon">-->
      <!--<img :src="`${baseUrl}images/dsds.png`" />-->

      <!--</div>-->
      <!--<div class="count">-->
      <!--3750-->
      <!--</div>-->
      <!--<div class="remark">-->
      <!--累计服务人数/人-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="stastic-sc-con-right">-->
      <!--<div class="icon">-->
      <!--<img :src="`${baseUrl}images/jskd.png`" />-->

      <!--</div>-->
      <!--<div class="count">-->
      <!--3750-->
      <!--</div>-->
      <!--<div class="remark">-->
      <!--统一身份认证/人-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->

      <!--</div>-->
      <!--<div class="stastic-sc-cell">-->
      <!--<div class="stastic-title">网站访问量</div>-->
      <!--<div class="stastic-sc-con">-->
      <!--<div class="stastic-sc-con-left">-->
      <!--<div class="icon">-->
      <!--<img :src="`${baseUrl}images/rtew.png`" />-->

      <!--</div>-->
      <!--<div class="count">-->
      <!--3750-->
      <!--</div>-->
      <!--<div class="remark">-->
      <!--当日访问量/次-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="stastic-sc-con-right">-->
      <!--<div class="icon">-->
      <!--<img :src="`${baseUrl}images/adad.png`" />-->

      <!--</div>-->
      <!--<div class="count">-->
      <!--3750-->
      <!--</div>-->
      <!--<div class="remark">-->
      <!--共计访问量/次-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->

      <!--</div>-->
      <!--<div class="stastic-sc-cell">-->
      <!--<div class="stastic-title">进驻部门与事项</div>-->
      <!--<div class="stastic-sc-con">-->
      <!--<div class="stastic-sc-con-left">-->
      <!--<div class="icon">-->
      <!--<img :src="`${baseUrl}images/yuki.png`" />-->

      <!--</div>-->
      <!--<div class="count">-->
      <!--3750-->
      <!--</div>-->
      <!--<div class="remark">-->
      <!--累计进驻部门/个-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="stastic-sc-con-right">-->
      <!--<div class="icon">-->
      <!--<img :src="`${baseUrl}images/jkuy.png`" />-->

      <!--</div>-->
      <!--<div class="count">-->
      <!--3750-->
      <!--</div>-->
      <!--<div class="remark">-->
      <!--累计进驻事项/个-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->

      <!--</div>-->
      <!--</div>-->
      <div class="stastic-warp po-r bor-ra" v-loading="pieLoading">
        <div class="stastic-title">部门服务进驻情况</div>
        <div>
          <div
            id="echartsPie"
            :style="{ width: '100%', height: '500px' }"
          ></div>
        </div>
      </div>

      <div class="stastic-warp bor-ra">
        <div class="stastic-title">效能详情</div>
        <div>
          <div class="table-area">
            <div class="search-area">
              <div class="w100 flex-box al-c sift-view">
                <DateComponent ref="date" @changehandle="handletime" />
                <el-button
                  class="ml10"
                  type="primary"
                  size="mini"
                  @click="searchPage"
                  >查询</el-button
                >
              </div>
            </div>
            <div class="echart-bar-warp cl-f">
              <div class="echart-left fl bor" v-loading="leftLoading">
                <div
                  id="echartsLeftLine"
                  :style="{ width: '100%', height: '320px' }"
                ></div>
              </div>
              <div class="echart-right fr bor" v-loading="rightLoading">
                <div class="search-box cl-f">
                  <div class="left">服务办理排行</div>
                  <div class="right">
                    <TreeSelect
                      size="small"
                      :data="departmentData"
                      clearable
                      expandAll
                      ref="deptSingle"
                      :obj="mapKey"
                      checkStrictly
                      @getValue="setDeptSingleMenu"
                    >
                    </TreeSelect>
                  </div>
                </div>
                <div
                  id="echartsRightTop"
                  :style="{ width: '100%', height: '110px' }"
                ></div>

                <div
                  id="echartsRightBottom"
                  class="mt20"
                  :style="{ width: '100%', height: '110px' }"
                ></div>
              </div>
            </div>

            <div class="table-con" v-loading="tableLoading">
              <div class="table-area-tab po-r">
                <span
                  :class="{ active: curTab == 'serve' }"
                  @click="setTabHandle('serve')"
                  >服务效能</span
                >
                <span
                  :class="{ active: curTab == 'dept' }"
                  @click="setTabHandle('dept')"
                  >部门效能</span
                >
                <span
                  :class="{ active: curTab == 'personal' }"
                  @click="setTabHandle('personal')"
                  >个人服务排行</span
                >
                <span
                  :class="{ active: curTab == 'nowSort' }"
                  @click="setTabHandle('nowSort')"
                  >当前待办排行</span
                >
                <!-- <el-button class="po-a" style="right:0" type="text" size="mini" @click="exportByServerOrDept">导出</el-button> -->
                <div
                  class="h100 po-a cu-p flex-box al-c"
                  style="right: 10px; bottom: 0"
                  title="导出"
                  @click="exportByServerOrDept"
                >
                  <img :src="`${baseUrl}images/excel2.svg`" alt="" />
                </div>
              </div>
              <div class="mt10">
                <el-table
                  class="w100 mt20 table"
                  v-if="curTab == 'serve'"
                  header-row-class-name="table-head"
                  row-class-name="cu-p"
                  stripe
                  :data="List"
                  @header-click="headerClick"
                >
                  <el-table-column
                    align="center"
                    label="服务名称"
                    width="200px"
                  >
                    <template slot-scope="scope">
                      <span class="bold font-16"
                        >{{ scope.row.serveName }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="belongDeptName"
                    label="责任部门"
                    width="200px"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="applyNum"
                    label="办理次数"
                  ></el-table-column>
                  <el-table-column align="center" label="结办次数">
                    <template slot-scope="scope">
                      <span>{{ scope.row.finNum }} </span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="结办率">
                    <template slot-scope="scope">
                      <span v-if="!!scope.row.applyNum"
                        >{{
                          (
                            (scope.row.finNum * 100) /
                            scope.row.applyNum
                          ).toFixed(2) + "%"
                        }}
                      </span>
                      <span v-else>0.00%</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    width="120px"
                    prop="maxCost"
                    label="最长时效（h）"
                  >
                    <template slot-scope="scope">
                      <span class="color-blue"
                        >{{ (scope.row.maxCost / 3600000).toFixed(2) }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    width="120px"
                    prop="minCost"
                    label="最短时效（h）"
                  >
                    <template slot-scope="scope">
                      <span class="color-blue"
                        >{{ (scope.row.minCost / 3600000).toFixed(2) }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    width="120px"
                    label="平均时效（h）"
                  >
                    <template slot-scope="scope">
                      <span v-if="!!scope.row.finNum" class="color-blue"
                        >{{
                          (
                            scope.row.sumCost /
                            scope.row.finNum /
                            3600000
                          ).toFixed(2)
                        }}
                      </span>
                      <span v-else>0.00</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    width="150px"
                    prop="avgPoints"
                    label="好差评"
                  >
                    <template slot-scope="scope">
                      <el-rate
                        :value="Number(scope.row.avgPoints)"
                        disabled
                      ></el-rate>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                      <div class="to-use">
                        <span class="info" @click="openDetail(scope.row)"
                          >查看详情</span
                        >
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table
                  class="w100 mt20 table"
                  v-if="curTab == 'dept'"
                  header-row-class-name="table-head"
                  row-class-name="cu-p"
                  stripe
                  :data="List"
                  @header-click="headerClick"
                >
                  <el-table-column
                    align="center"
                    label="部门名称"
                    width="200px"
                  >
                    <template slot-scope="scope">
                      <span class="bold font-16"
                        >{{ scope.row.deptName }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="applyCount"
                    label="办理次数"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="finCount"
                    label="结办次数"
                  ></el-table-column>
                  <el-table-column align="center" label="结办率">
                    <template slot-scope="scope">
                      <span v-if="!!scope.row.applyCount"
                        >{{
                          (
                            (scope.row.finCount * 100) /
                            scope.row.applyCount
                          ).toFixed(2) + "%"
                        }}
                      </span>
                      <span v-else>0.00%</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    width="120px"
                    prop="maxCost"
                    label="最长时效（h）"
                  >
                    <template slot-scope="scope">
                      <span class="color-blue"
                        >{{ (scope.row.maxCost / 3600000).toFixed(2) }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    width="120px"
                    prop="minCost"
                    label="最短时效（h）"
                  >
                    <template slot-scope="scope">
                      <span class="color-blue"
                        >{{ (scope.row.minCost / 3600000).toFixed(2) }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    width="120px"
                    label="平均时效（h）"
                  >
                    <template slot-scope="scope">
                      <span v-if="!!scope.row.finCount" class="color-blue"
                        >{{
                          (
                            scope.row.costTime /
                            scope.row.finCount /
                            3600000
                          ).toFixed(2)
                        }}
                      </span>
                      <span v-else>0.00</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                      <div class="to-use">
                        <span class="info" @click="openDetail(scope.row)"
                          >查看详情</span
                        >
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table
                  class="w100 mt20 table"
                  v-if="curTab == 'personal'"
                  header-row-class-name="table-head"
                  row-class-name="cu-p"
                  stripe
                  :data="List"
                  @header-click="headerClick"
                >
                  <el-table-column align="center" label="姓名" width="200px">
                    <template slot-scope="scope">
                      <span class="bold font-16"
                        >{{ scope.row.username }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="applyCount"
                    label="办理次数"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="endCount"
                    label="结办次数"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    label="结办率"
                    prop="endRatio"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.endRatio }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    width="120px"
                    prop="maxTime"
                    label="最长时效（h）"
                  >
                    <template slot-scope="scope">
                      <span class="color-blue"
                        >{{ (scope.row.maxTime / 3600000).toFixed(2) }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    width="120px"
                    prop="minTime"
                    label="最短时效（h）"
                  >
                    <template slot-scope="scope">
                      <span class="color-blue"
                        >{{ (scope.row.minTime / 3600000).toFixed(2) }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    width="120px"
                    label="平均时效（h）"
                  >
                    <template slot-scope="scope">
                      <span class="color-blue"
                        >{{ (scope.row.avgTime / 3600000).toFixed(2) }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                      <div class="to-use">
                        <span class="info" @click="openDetail(scope.row)"
                          >查看详情</span
                        >
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <!-- 当前待办排行 -->
                <el-table
                  class="w100 mt20 table"
                  v-if="curTab == 'nowSort'"
                  header-row-class-name="table-head"
                  row-class-name="cu-p"
                  stripe
                  :data="List"
                  @header-click="headerClick"
                >
                  <el-table-column align="center" label="姓名" width="200px">
                    <template slot-scope="scope">
                      <span class="bold font-16"
                        >{{ scope.row.username }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="userNo"
                    label="教职工号"
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="phone"
                    label="电话"
                  ></el-table-column>
                  <el-table-column align="center" prop="bpmName" label="部门">
                    <template slot-scope="scope">
                      {{ scope.row.bpmName }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    prop="number"
                    label="待办总数"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.number }}
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                      <div class="to-use">
                        <span class="info" @click="openDetail(scope.row)"
                          >查看详情</span
                        >
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
            <div class="mt20 cl-f">
              <div class="fr">
                <el-pagination
                  background
                  @size-change="changeSize"
                  @current-change="changePage"
                  :page-sizes="pageSizes"
                  :current-page="stasticParams.current"
                  :page-size="stasticParams.size"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <detailShow ref="detailShow"></detailShow>
  </div>
</template>

<script>
import {
  bpmnHeadStastic,
  bpmnChatStastic,
  bpmnPageServeStastic,
  bpmnPageDeptStastic,
  bpmnStuAndteachStastic,
  bpmnByTimesStastic,
  exportServeStastic,
  bpmnPagePersonalStastic,
  bpmnPageNowSortStastic,
  pagePersonalStasticDetail,
  pagePersonalStasticHandleDetail,
} from "@/api/bpmnApi/bpmn";
import DateComponent from "@/components/public/DateComponent";
import detailShow from "@/views/statistical/all/detailShow";
import TreeSelect from "@/components/TreeSelect.vue";
import { getDeptTree } from "@/api/managementCenter/otherApi";
export default {
  name: "all",
  components: {
    DateComponent,
    TreeSelect,
    detailShow,
  },
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      headJson: {},
      chartJson: {},
      curTab: "serve",
      List: [],
      pageSizes: [10, 20, 30, 50, 100],
      headLoading: false,
      pieLoading: false,
      tableLoading: false,
      leftLoading: false,
      rightLoading: false,
      total: 0,
      stasticParams: {
        current: 1,
        size: 20,
        beginTime: "",
        endTime: "",
      },
      mapKey: {
        id: "id", // ID
        label: "name", // 显示名称
        children: "children", //子级字段名
      },
      departmentData: [],
      type: "0",
      deptId: "",
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.getBpmnHeadStastic();
    this.getBpmnChatStastic();
    let arr = this.$refs.date.getValueStr();
    this.stasticParams.beginTime = arr[0];
    this.stasticParams.endTime = arr[1];
    this.initPage();
    this.getBpmnStuAndteachStastic();
    this.getBpmnByTimesStastic();
    this.getDeptTreeData();
  },
  destroyed() {},
  methods: {
    exportByServerOrDept() {
      let path;
      path =
        this.curTab == "serve"
          ? "/admin/bpmn/stastics/exportServeStastic"
          : this.curTab == "dept"
          ? "/admin/bpmn/stastics/exportDeptStastic"
          : this.curTab == "personal"
          ? "/admin/bpmn/stastics/exportPersonalStastic"
          : "/admin/bpmn/stastics/exportUndoneTaskCountc";
      this.$DownLoadL(
        path + "?" + this.$qs.stringify(this.stasticParams),
        null,
        (res) => {
          if (res.status == 200) {
            // this.$message.success("开始下载");
          } else {
            this.$alert("下载出错,请稍后重试", "提示", {
              confirmButtonText: "确定",
              type: "warning",
            });
          }
        },
        (error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
            type: "warning",
          });
        }
      );
    },
    openDetail(item) {
      this.$refs.detailShow.dialogShow(item, this.stasticParams, this.curTab);
    },
    setDeptSingleMenu(key, data) {
      //获取子组件值
      this.deptId = data.id;
      this.getBpmnStuAndteachStastic();
    },
    getDeptTreeData() {
      getDeptTree()
        .then(({ data }) => {
          if (data.code == 0) {
            if (data.data && data.data.length > 0) {
              if (data.data[0].id == 1) {
                this.departmentData = data.data[0].children;
              } else {
                this.departmentData = data.data;
              }
            }
          }
        })
        .catch((err) => {});
    },
    // 条数
    changeSize(value) {
      this.stasticParams.size = value;
      this.stasticParams.current = 1;
      this.initPage();
    },
    // 翻页
    changePage(value) {
      this.stasticParams.current = value;
      this.initPage();
    },
    setTabHandle(text) {
      this.curTab = text;
      this.stasticParams.current = 1;
      this.stasticParams.size = 20;
      this.total = 0;
      this.initPage();
    },
    setRightEchart(data, subtext, id) {
      data.sort(function (t1, t2) {
        return t1.cnt - t2.cnt;
      });
      if (data.length > 3) {
        data = data.slice(data.length - 3, data.length);
      }
      let labelList = data.map((i) => i.serveName || "");
      let numList = data.map((i) => i.cnt);
      let dom = document.getElementById(id);
      let myChart = this.echarts.init(dom);
      let myColor = ["#4979BC", "#EDBBD5", "#1FAF92"];
      let option = {
        // title: {
        //     subtext:subtext,      //副标题
        //     subtextStyle:{          //对应样式
        //         color :'#6B6B6B',
        //         fontWeight :'700',
        //         fontSize :'14'
        //     }
        // },
        title: {
          text: subtext,
          padding: [10, 35, 0, 200],
          textStyle: {
            color: "#6B6B6B",
            fontWeight: "700",
            fontSize: "12",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "5%",
          right: "4%",
          bottom: 0,
          top: 35,
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          show: false,
        },
        yAxis: {
          type: "category",
          data: labelList,
          axisTick: {
            show: false,
          },
          axisLine: {
            //y轴
            show: false,
          },
        },
        series: [
          {
            name: "次数",
            barWidth: 8, //设置柱子宽度
            type: "bar",
            data: numList,
            itemStyle: {
              normal: {
                label: {
                  formatter: "{c}" + "次",
                  show: true,
                  position: "right",
                  textStyle: {
                    fontSize: "12",
                    color: "#ccc",
                  },
                },
                color: (params) => {
                  let index = params.dataIndex;
                  let num = myColor.length;
                  return myColor[index % num];
                },
              },
            },
          },
        ],
      };
      if (option && typeof option === "object") {
        myChart.setOption(option, true);
      }
    },
    setLeftEchart(data) {
      let labelList = data.map((i) => i.name || "");
      let dealNumList = data.map((i) => i.dealNum);
      let applyNumList = data.map((i) => i.applyNum);
      let dom = document.getElementById("echartsLeftLine");
      let myChart = this.echarts.init(dom);
      let option = {
        title: {
          text: "服务趋势",
          padding: [10, 35, 0, 20],
          textStyle: {
            color: "#6B6B6B",
            fontWeight: "700",
            fontSize: "14",
          },
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["服务次数", "服务人数"],
          bottom: 10, //legend距离canvas上面的距离
        },
        grid: {
          left: "10%",
          width: "80%",
          containLabel: false,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: labelList,
        },
        yAxis: {
          name: "数量",
        },
        series: [
          {
            name: "服务次数",
            type: "line",
            smooth: true,
            lineStyle: {
              color: "#81D3CB",
            },
            color: "#81D3CB",
            data: applyNumList,
          },
          {
            name: "服务人数",
            type: "line",
            smooth: true,
            color: "#99ACFF",
            lineStyle: {
              color: "#99ACFF",
            },
            data: dealNumList,
          },
        ],
      };
      if (option && typeof option === "object") {
        myChart.setOption(option, true);
      }
    },
    setChart(data) {
      let lineColor = ["#7E74F8", "#D97AE1", "#F0755E"];
      let deptColor = [
        "#3560E5",
        "#436BE7",
        "#5276E9",
        "#6182EB",
        "#6F8DEC",
        "#7D99EE",
        "#8BA4F0",
        "#9AAFF2",
        "#A9BBF4",
        "#32DFA0",
        "#64E7B7",
        "#9AAFF2",
      ];
      let depts = (data.depts || []).map((i) => {
        return { ...i, name: i.deptName, value: i.all };
      });

      let line = [];
      (data.line || []).forEach((i) => {
        if (Number(i.cnt) > 0) {
          line.push({ name: i.name, value: i.cnt });
        }
      });

      let dom = document.getElementById("echartsPie");
      let myChart = this.echarts.init(dom);
      let option = {
        tooltip: {
          trigger: "item",
          formatter(params, cell) {
            let obj = params.data;
            if (cell.indexOf("dept") == -1) {
              return "";
            }
            return `${obj.name}  (${params.percent}% 全部：${obj.all},线上 ：${obj.online},线下：${obj.offline},线上和线下：${obj.onlineAndOffline})`;
          },
        },

        series: [
          {
            type: "pie",
            selectedMode: "single",
            radius: [0, "36%"],
            label: {
              formatter: "{b}\n{c}",
              position: "inner",
            },
            labelLine: {
              show: false,
            },
            data: line,
            itemStyle: {
              // emphasis: {
              //     borderWidth: 0,
              //     shadowBlur: 10,
              //     shadowOffsetX: 0,
              //     shadowColor: 'rgba(0, 0, 0, 0.5)',
              // },
              normal: {
                borderWidth: 2,
                borderColor: "#ffffff",
                color: (params) => {
                  let index = params.dataIndex;
                  let num = lineColor.length;
                  return lineColor[index % num];
                },
              },
            },
          },
          {
            name: "dept",
            type: "pie",
            radius: ["44%", "58%"],
            label: {
              formatter(params, cell) {
                let obj = params.data;
                return `${obj.name}  (${params.percent}%)`;
              },
              color: "#999999",
              backgroundColor: "#fff",
              fontSize: 13,
              padding: [0, 7],
              rich: {
                a: {
                  color: "#999",
                  lineHeight: 22,
                  align: "center",
                },
                hr: {
                  backgroundColor: "#fff",
                  width: "100%",
                  borderWidth: 0.5,
                  height: 0,
                },
                b: {
                  fontSize: 12,
                  lineHeight: 20,
                },
                per: {
                  color: "#eee",
                  backgroundColor: "#fff",
                  padding: [2, 4],
                  borderRadius: 2,
                },
              },
            },
            data: depts,
            itemStyle: {
              normal: {
                borderWidth: 2,
                borderColor: "#ffffff",
                color: (params) => {
                  let index = params.dataIndex;
                  let num = deptColor.length;
                  return deptColor[index % num];
                },
              },
            },
          },
        ],
      };
      if (option && typeof option === "object") {
        myChart.setOption(option, true);
      }
    },
    getBpmnHeadStastic() {
      this.headLoading = true;
      bpmnHeadStastic()
        .then(({ data }) => {
          this.headLoading = false;
          if (data.code == 0) {
            this.headJson = data.data || {};
          }
        })
        .catch((err) => {
          this.headLoading = false;
        });
    },
    getBpmnChatStastic() {
      this.pieLoading = true;
      bpmnChatStastic()
        .then(({ data }) => {
          this.pieLoading = false;
          if (data.code == 0) {
            this.setChart(data.data);
          }
        })
        .catch((err) => {
          this.pieLoading = false;
        });
    },
    initPage() {
      this.tableLoading = true;
      let method = bpmnPageServeStastic;
      if (this.curTab == "dept") {
        method = bpmnPageDeptStastic;
      }
      if (this.curTab == "personal") {
        method = bpmnPagePersonalStastic;
      }
      if (this.curTab == "nowSort") {
        method = bpmnPageNowSortStastic;
      }

      method(this.stasticParams)
        .then(({ data }) => {
          this.tableLoading = false;
          if (data.code == 0) {
            if (data.data) {
              this.List = data.data.records;
              this.total = data.data.total;
            }
          } else {
            this.List = [];
            this.total = 0;
          }
        })
        .catch((err) => {
          this.List = [];
          this.total = 0;
          this.tableLoading = false;
        });
    },

    getBpmnByTimesStastic() {
      this.leftLoading = true;
      let type = {
        type: this.type,
      };
      bpmnByTimesStastic({ ...this.stasticParams, ...type })
        .then(({ data }) => {
          this.leftLoading = false;
          if (data.code == 0) {
            this.setLeftEchart(data.data || []);
          }
        })
        .catch((err) => {
          this.leftLoading = false;
        });
    },
    getBpmnStuAndteachStastic() {
      this.rightLoading = true;
      let deptId = {
        deptId: this.deptId,
      };
      bpmnStuAndteachStastic({ ...this.stasticParams, ...deptId })
        .then(({ data }) => {
          this.rightLoading = false;
          if (data.code == 0) {
            this.setRightEchart(
              data.data.teacher || [],
              "老师办理服务TOP3",
              "echartsRightTop"
            );
            this.setRightEchart(
              data.data.stu || [],
              "学生办理服务TOP3",
              "echartsRightBottom"
            );
          }
        })
        .catch((err) => {
          this.rightLoading = false;
        });
    },

    searchPage() {
      let arr = this.$refs.date.getValueStr();
      this.stasticParams.beginTime = arr[0];
      this.stasticParams.endTime = arr[1];
      this.stasticParams.current = 1;
      this.stasticParams.size = 20;
      this.type = 5;
      this.initPage();
      this.getBpmnStuAndteachStastic();
      this.getBpmnByTimesStastic();
    },
    handletime(arr, value) {
      this.stasticParams.beginTime = arr[0];
      this.stasticParams.endTime = arr[1];
      this.stasticParams.current = 1;
      this.stasticParams.size = 20;
      this.type = value;
      this.initPage();
      this.getBpmnStuAndteachStastic();
      this.getBpmnByTimesStastic();
    },
    headerClick(val) {
      console.log(val);
      switch (val.label) {
        case "办理次数":
          this.stasticParams.order = 0;
          this.initPage();
          break;
        case "结办次数":
          this.stasticParams.order = 1;
          this.initPage();
          break;
        case "结办率":
          this.stasticParams.order = 2;
          this.initPage();
          break;
        case "最长时效（h）":
          this.stasticParams.order = 3;
          this.initPage();
          break;
        case "最短时效（h）":
          this.stasticParams.order = 4;
          this.initPage();
          break;
        case "平均时效（h）":
          this.stasticParams.order = 5;
          this.initPage();
          break;
        case "好差评":
          this.stasticParams.order = 6;
          this.initPage();
          break;
        default:
          this.stasticParams.order = "";
          this.initPage();
      }
      if (val.property == "endCount") {
      }
    },
  },
  watch: {},
  filters: {},
};
</script>
<style lang="less" scoped>
/deep/.table-head th {
  cursor: pointer;
}
.to-use span.info {
  display: inline-block;
  font-size: 14px;
  width: 70px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  cursor: pointer;
  background: #49a4f0;
  color: white;
}
/deep/tbody tr {
  height: 60px !important;
}
.statistical {
  background: #f2f3f6;
  .color-blue {
    color: #2a84dc;
  }
  > div {
    .stastic-title {
      height: 20px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      // color: #064576;
      line-height: 20px;
      margin-bottom: 10px;
      // border-left: 4px solid #064576;
      padding-left: 15px;
      margin-left: -15px;
    }
    margin: 0 auto;
    width: 1300px;
    .stastic-warp {
      padding: 0 15px;
      padding-top: 10px;
      background: white;
      padding-bottom: 20px;
      margin-bottom: 15px;
      overflow: hidden;
      .table-area {
        width: 100%;
        .search-area {
          padding-top: 20px;
        }
        .echart-bar-warp {
          padding: 30px 0;
          > div {
            height: 320px;
          }
          .echart-left {
            width: 49%;
          }
          .echart-right {
            width: 49%;
            .search-box {
              padding: 10px;
              .left {
                width: 200px;
                float: left;
                font-size: 14px;
                font-weight: bold;
                height: 35px;
                color: #6b6b6b;
                line-height: 20px;
                padding-left: 10px;
              }
              .right {
                width: 200px;
                float: right;
              }
            }
          }
        }
        .table-area-tab {
          text-align: center;
          > span {
            display: inline-block;
            margin: 0 20px;
            font-size: 18px;
            cursor: pointer;
            &.active {
              // color: #064576;
              font-weight: bold;
              // border-bottom: 2px solid #064576;
              height: 36px;
              line-height: 36px;
              position: relative;
              // &:after {
              //   content: '';
              //   display: block;
              //   width: 0;
              //   height: 0;
              //   border: 5px solid transparent;
              //   position: absolute;
              //   bottom: -11px;
              //   z-index: 0;
              //   border-top: 5px solid #064576;
              //   right: 30px;
              // }
            }
          }
        }
      }
      .stastic-head-warp {
        width: 100%;
        display: flex;
        color: #fff;

        .stastic-head-cell {
          flex: 1;
          border-radius: 5px;
          height: 108px;
          margin: 0 12px;
          display: flex;
          justify-items: center;
          justify-content: center;
          flex-direction: column;
          position: relative;
          background-position: -48px -26px;
          background-repeat: no-repeat;
          overflow: hidden;
          &:nth-child(1) {
            background-color: #6aa1fb;
          }
          &:nth-child(2) {
            background-color: #36c2cf;
          }
          &:nth-child(3) {
            background-color: #e7ac54;
          }
          &:nth-child(4) {
            background-color: #a78af2;
          }
          &:nth-child(5) {
            background-color: #f0755e;
          }
          > .cell-icon {
            position: absolute;
            bottom: -12px;
            right: -12px;
            width: 80px;
            height: 80px;
            z-index: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 100%;
            background-color: rgba(0, 0, 0, 0.1);
            > img {
              width: 38%;
            }
          }
          > .cell-item {
            .cell-left {
              padding-left: 20px;
              float: left;
              .cell-left-sum {
                font-size: 18px;
                padding-bottom: 6px;
                span {
                  font-size: 12px;
                }
              }
            }
            /*↑→↓*/
            .cell-right {
              float: left;
              padding-left: 30px;
              padding-top: 6px;
              font-size: 22px;
              .flag {
                font-size: 25px;
                font-size: 28px;
                display: inline-block;
                padding: 0 4px;
                margin-top: -9px;
                vertical-align: top;
              }
            }
          }
        }
      }
    }
    /*.stastic-sc{*/
    /*margin-bottom: 15px;*/
    /*width: 100%;*/
    /*&-cell {*/
    /*float: left;*/
    /*height: 190px;*/
    /*background: white;*/
    /*width: 390px;*/
    /*padding: 0 15px;*/
    /*&:nth-child(2){*/
    /*margin: 0 15px;*/
    /*}*/
    /*.stastic-sc-con{*/
    /*width: 100%;*/
    /*padding-top: 10px;*/
    /*>div{*/
    /*width: 50%;*/
    /*float:left ;*/

    /*.icon{*/
    /*width: 60px;*/
    /*height: 60px;*/
    /*margin: 0 auto;*/
    /*>img{*/
    /*width: 100%;*/
    /*vertical-align: bottom;*/
    /*}*/
    /*}*/
    /*.count{*/
    /*text-align: center;*/
    /*font-size: 18px;*/
    /*padding: 8px 0;*/
    /*font-weight: bold;*/
    /*}*/
    /*.remark{*/
    /*text-align: center;*/
    /*font-size: 14px;*/
    /*color: #ccc;*/
    /*}*/
    /*}*/
    /*}*/
    /*}*/

    /*}*/
  }
  // /deep/.el-table {
  //   th{
  //     background: #E8F2FA!important;
  //     border-top: 1px solid #4D8ABA;
  //     border-bottom: 1px solid #4D8ABA;
  //   }
  // }
}
</style>


